import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class MenuSetting {
    list(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.menuSetting}?${params}`)
    }

    create(data) {
        return BaseService.post(`${APIPath.menuCreate}`, data)
    }

    update(id, data) {
        return BaseService.put(`${APIPath.menuUpdate}/${id}`, data)
    }

    menuPermission(menuId) {
        return BaseService.get(
            `${APIPath.menuPermission}/${menuId}/Permissions`,
        )
    }

    menuPermissionAssign(menuId, permissionId) {
        return BaseService.post(
            `${APIPath.menuPermissionAssignRemove}/${menuId}/Permission/${permissionId}`,
            {},
        )
    }

    menuPermissionRemove(menuId, permissionId) {
        return BaseService.remove(
            `${APIPath.menuPermissionAssignRemove}/${menuId}/Permission/${permissionId}`,
        )
    }

    delete(id) {
        return BaseService.post(`${APIPath.menuUpdate}/${id}/Remove`)
    }

    menuDefaultsList() {
        return BaseService.get(APIPath.menuDefaults)
    }

    menuDefaultsSave(data) {
        return BaseService.post(APIPath.menuDefaultsSave, data)
    }
}

const MenuSettingService = new MenuSetting()
Object.freeze(MenuSettingService)
export { MenuSettingService }
